import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnion = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7_27)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8 0C6.89543 0 6 0.89543 6 2V6H2C0.89543 6 0 6.89543 0 8V18C0 19.1046 0.89543 20 2 20H12C13.1046 20 14 19.1046 14 18V14H18C19.1046 14 20 13.1046 20 12V2C20 0.89543 19.1046 0 18 0H8ZM14 14V8C14 6.89543 13.1046 6 12 6H6V12C6 13.1046 6.89543 14 8 14H14Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M6 12C6 13.1046 6.89543 14 8 14H14V8C14 6.89543 13.1046 6 12 6H6V12Z",
			fill: "currentColor"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7_27",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgUnion;
